var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoContestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8399 2.18005L16.9099 2.96005L19.6499 6.50005L21.6199 6.10005L20.8399 2.18005ZM13.9699 3.54005L11.9999 3.93005L14.7499 7.46005L16.7099 7.07005L13.9699 3.54005ZM9.06993 4.50005L7.09993 4.91005L9.84993 8.44005L11.8099 8.05005L9.06993 4.50005ZM4.15993 5.50005L3.17993 5.69005C2.66032 5.79387 2.20314 6.09965 1.90877 6.54026C1.61441 6.98086 1.50693 7.52027 1.60993 8.04005L1.99993 10.0001L6.89993 9.03005L4.15993 5.50005ZM1.99993 10.0001V20.0001C1.99993 20.5305 2.21065 21.0392 2.58572 21.4143C2.96079 21.7893 3.4695 22.0001 3.99993 22.0001H19.9999C21.1099 22.0001 21.9999 21.1101 21.9999 20.0001V10.0001H1.99993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoContestIcon);
export default __webpack_public_path__ + "static/media/videoContestIcon.e9e76ff2ad05caa00b61187eeaf0d2a3.svg";
export { ForwardRef as ReactComponent };